<template>
  <el-dialog
    :title="name"
    :visible.sync="dialogVisible"
    width="60%"
    :before-close="handleClose"
  >
    <el-form
      ref="from"
      :model="adminInfo"
      label-width="auto"
      size="medium"
      :rules="rules"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="操作员姓名" prop="name">
            <el-input v-if="!isViewMode" v-model="adminInfo.name" />
            <template v-else>
              {{ adminInfo.name }}
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账号" prop="username">
            <el-input v-if="!isViewMode" v-model="adminInfo.username" />
            <template v-else>
              {{ adminInfo.username }}
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="员工编号" prop="xsc_user_id">
            <el-input
              v-if="!isViewMode"
              v-model="adminInfo.xsc_user_id"
              :disabled="true"
            />
            <template v-else>
              {{ adminInfo.xsc_user_id }}
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="!isViewMode" label="密码" prop="password">
            <el-input type="password" v-model="adminInfo.password" />
          </el-form-item>
        </el-col>
      </el-row>
<!--      <el-row>-->
<!--        <el-col :span="12">-->
<!--          <el-form-item label="证件类型" prop="id_type">-->
<!--            <el-select v-if="!isViewMode" v-model="adminInfo.id_type">-->
<!--              <el-option-->
<!--                v-for="item in idTypeLists"-->
<!--                :key="item.id"-->
<!--                :label="item.name"-->
<!--                :value="item.id"-->
<!--              />-->
<!--            </el-select>-->
<!--            <template v-else>-->
<!--              {{ adminInfo.id_type }}-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <el-form-item label="证件号码" prop="id_number">-->
<!--            <el-input v-if="!isViewMode" v-model="adminInfo.id_number" />-->
<!--            <template v-else>-->
<!--              {{ adminInfo.id_number }}-->
<!--            </template>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
<!--      </el-row>-->
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号码" prop="phone_number">
            <el-input v-if="!isViewMode" v-model="adminInfo.phone_number" />
            <template v-else>
              {{ adminInfo.phone_number }}
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司电话" prop="company_phone">
            <el-input v-if="!isViewMode" v-model="adminInfo.company_phone" />
            <template v-else>
              {{ adminInfo.company_phone }}
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="部门" prop="department_id">
            <template v-if="!isViewMode">
              <span v-if="!changeDepartment">
                {{ adminInfo.ancestor_name }}
              </span>
              <el-cascader
                v-else
                v-model="adminInfo.department_id"
                placeholder="可输入部门名称搜索"
                :options="jurisdictionList"
                :filterable="true"
                :props="props"
                style="width: 80%"
              ></el-cascader>
              <el-button
                type="text"
                @click="changeDepartmentMode(changeDepartment)"
                >{{ changeDepartment ? "取消" : "修改" }}
              </el-button>
            </template>
            <template v-else> {{ adminInfo.ancestor_name }}</template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="角色" prop="roleIds">
            <el-select
              v-if="!isViewMode"
              v-model="adminInfo.roleIds"
              filterable
              multiple
              placeholder="选择角色"
              style="width: 100%"
            >
              <el-option
                v-for="item in RoleLists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <template v-else>
              <el-tag
                v-for="(item, key) in adminInfo.roleNames"
                :key="key"
                style="margin-right: 3px"
              >
                {{ item }}
              </el-tag>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="status">
            <el-select
              v-if="!isViewMode"
              v-model="adminInfo.status"
              filterable
              placeholder="选择状态"
              :clearable="true"
            >
              <el-option
                v-for="item in adminStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <template v-else>
              {{ adminInfo.status == 1 ? "在用" : "禁用" }}
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="直接下属" prop="subordinates">
            <el-select
              v-if="!isViewMode"
              v-model="adminInfo.subordinates"
              filterable
              placeholder="选择操作员"
              :clearable="true"
              multiple
              :remote="true"
              :remote-method="remoteMethod"
              style="width: 100%"
            >
              <el-option
                v-for="item in adminLists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <template v-else>
              <el-tag
                v-for="(item, key) in adminInfo.subordinateNames"
                :key="key"
                style="margin-right: 3px"
              >
                {{ item }}
              </el-tag>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="管理部门" prop="extendDepartmentIds">
            <template v-if="!isViewMode">
              <template v-if="!changeExtendDepartment">
                <el-tag
                  v-for="(item, key) in adminInfo.extendDepartmentNames"
                  :key="key"
                  style="margin-right: 3px"
                >
                  {{ item }}
                </el-tag>
              </template>
              <el-cascader
                v-else
                v-model="adminInfo.extendDepartmentIds"
                placeholder="可输入部门名称搜索"
                :options="jurisdictionList"
                :filterable="true"
                :props="props2"
                style="width: 80%"
              ></el-cascader>
              <el-button
                type="text"
                @click="changeExtendDepartmentMode(changeExtendDepartment)"
                >{{ changeExtendDepartment ? "取消" : "修改" }}</el-button
              >
            </template>
            <template v-else>
              <el-tag
                v-for="(item, key) in adminInfo.extendDepartmentNames"
                :key="key"
                style="margin-right: 3px"
              >
                {{ item }}
              </el-tag>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button v-if="isViewMode" type="primary" plain @click="changeMode"
          >编辑</el-button
        >
        <el-button v-else type="primary" plain @click="save">保存</el-button>
        <el-button plain @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
  <script>
import Http from "@/components/Admin/Flow/common/Http";
export default {
  name: "OperatorDetail",
  props: {
    mode: {
      type: String,
      default: "add",
    },
    id: {
      type: Number | String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      adminInfo: {
        name: "",
        username: "",
        password: "",
        subordinates: [],
        xsc_user_id: "",
        id_type: 1,
        id_number: "",
        phone_number: "",
        department_id: "",
        roleIds: [],
        status: 1,
        extendDepartmentIds: [],
        company_phone: "",
        subordinateNames: [],
        extendDepartmentNames: [],
        roleNames: [],
      },
      pattern: "view",
      changeDepartment: false,
      changeExtendDepartment: false,
      jurisdictionList: [],
      rules: {
        name: [
          { required: true, message: "请填写操作员姓名", trigger: "blur" },
        ],
        username: [
          { required: true, message: "请填写操作员账号", trigger: "blur" },
        ],
        id_type: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        id_number: [
          { required: true, message: "请填写证件号码", trigger: "blur" },
        ],
        phone_number: [
          { required: true, message: "请填写手机号码", trigger: "blur" },
        ],
        department_id: [
          { required: true, message: "请选择部门", trigger: "blur" },
        ],
        roleIds: [{ required: true, message: "请选择角色", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      props: {
        value: "id",
        label: "department_name",
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          var region_id = node.data.id; //选中节点id
          setTimeout(() => {
            //节点不能为空
            if (region_id == "" || region_id == undefined) {
              return false;
            }
            //加载
            node.data.region_id = region_id;
            node.data &&
              Http.get(
                "hrm/department/list",
                { parent_id: node.data.id },
                (backdata) => {
                  return resolve(backdata.data);
                }
              );
          }, 300);
        },
      },
      props2: {
        value: "id",
        label: "department_name",
        lazy: true,
        multiple: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          var region_id = node.data.id; //选中节点id
          setTimeout(() => {
            //节点不能为空
            if (region_id == "" || region_id == undefined) {
              return false;
            }
            //加载
            node.data.region_id = region_id;
            node.data &&
              Http.get(
                "hrm/department/list",
                { parent_id: node.data.id },
                (backdata) => {
                  return resolve(backdata.data);
                }
              );
          }, 300);
        },
      },
      RoleLists: [],
      adminStatus: [
        {
          label: "在用",
          value: 1,
        },
        {
          label: "禁用",
          value: 0,
        },
      ],
      adminLists: [],
      idTypeLists: [],
    };
  },
  mounted() {
    this.detail();
    this.departmentList();
    this.getRoleList();
    this.remoteMethod();
    this.getIdType();
  },
  computed: {
    __MENU_LIST__() {
      return ERP.getStore().__MENU_LIST__;
    },
    isViewMode() {
      if (this.pattern === "view") {
        return true;
      }
      return false;
    },
  },
  watch: {
    dialogVisible(n, o) {
      if(n == true) {
        this.detail();
      }
    },
    mode(n) {
      this.pattern = n;
      if (n === "add") {
        this.adminInfo = {
          name: "",
          username: "",
          password: "",
          subordinates: [],
          xsc_user_id: "",
          id_type: 1,
          id_number: "",
          phone_number: "",
          department_id: "",
          roleIds: [],
          status: 1,
          extendDepartmentIds: [],
          company_phone: "",
          subordinateNames: [],
          extendDepartmentNames: [],
          roleNames: [],
        };
      }
    },
  },
  methods: {
    handleClose() {
      this.changeDepartment = false,
      this.changeExtendDepartment = false,
      this.$emit("close", false);
    },
    detail() {
      if (this.id == null || this.id == 0) {
        return;
      }
      Http.post("hr/user/viewUser", { id: this.id }, (res) => {
        this.adminInfo = res.adminInfo;
      });
    },
    changeMode() {
      this.pattern = "edit";
    },
    departmentList() {
      Http.get("hrm/department/list", {}, (res) => {
        if (res.code === 0) {
          this.jurisdictionList = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    save() {
      var url = "";
      if (this.pattern == "add") {
        url = "hr/user/addAdmin";
      } else {
        url = "hr/user/editUser";
      }
      if (this.id != null) {
        this.adminInfo.id = this.id;
      }
      if (this.adminInfo.extendDepartmentIds.length > 0) {
        var arr = [];
        for (var item of this.adminInfo.extendDepartmentIds) {
          arr.push(item.pop());
        }
        this.adminInfo.extendDepartmentIds = arr;
      }
      if (this.adminInfo.department_id.length > 0) {
        var departmentId = this.adminInfo.department_id.pop();
        this.adminInfo.department_id = departmentId
      }
      this.$refs["from"].validate((valid) => {
        if (valid) {
          Http.post(url, this.adminInfo, (res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.handleClose();
            } else {
              this.$message.error(res.msg);
              this.handleClose();
            }
          });
        } else {
          return false;
        }
      });
    },
    changeDepartmentMode(row) {
      this.changeDepartment = !row;
    },
    changeExtendDepartmentMode(row) {
      this.changeExtendDepartment = !row;
    },
    getRoleList() {
      Http.post("flow/role/searchList", {}, (res) => {
        this.RoleLists = res.RoleInfos;
      });
    },
    remoteMethod(keyword) {
      Http.post(
        "hr/user/searchAdmin",
        { keyword: keyword, ids: this.adminInfo.subordinates },
        (res) => {
          this.adminLists = res.data;
        }
      );
    },
    getIdType() {
      Http.post("hr/IDType/getIdType", {}, (res) => {
        this.idTypeLists = res.data;
      });
    },
  },
};
</script>

  <style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/Operator/OperatorDetail.vue